import Vue from 'vue'
import gql from 'graphql-tag'

const query = gql`
  query person ($id: ID!) {
  person (id: $id) {
    id
    status
    name
    birthday
		documentNumber
		classification
    gender
    email
    phoneNumber
		cellphoneNumber
    payments {
      paidAt
    }
    importFile {
      createdAt
      provider
      filename
      campaign {
        name
      }
    }
    address {
      id
      street
      number
      neighbour
      postalCode
      complement
      city
      state
    }
    paymentSlipRegisterAttempt {
      id
      errors
			paymentSlipInfo {
				documentNumber
				nossoNumero
				value
        dueDate
        boletoCode
        boletoUrl
				beneficiaryCode
        wallet
			}
		}
  }
}`

/**
* @param {*} id
**/

async function getPerson ( params ) {
  const { $api } = Vue.prototype
  const data = await $api.query({
    query,
    fetchPolicy: 'no-cache',
    variables: params
  }).then( res => res)
  .catch( e => e )
  return data;
}

export { getPerson }
